import {SearchParamsInterface} from "../interface/SearchParamsInterface";
import configAxios from "../configuration/configAxios";
import {interceptorResponse} from "../../utils/decode/decoding";
import {errorHandlerServices, getError} from "../configuration/errorHandle";
import {useMutation, UseMutationResult} from "@tanstack/react-query";
// import {msjLine} from "../../layouts/components/InfoOnline";
import {CriminalRecordInterface} from "../interface/query/legal-information/criminal-record-interface";
import {DemandsInterface} from "../interface/query/legal-information/demands-interface";
import {ComplaintInterface} from "../interface/query/legal-information/complaint-interface";
import {SupaInterface} from "../interface/query/legal-information/supa/supa-interface";

export const findCriminalRecords = async (data: SearchParamsInterface) => {
    return await configAxios.post(
        `/legal_cases/criminal_record`,
        {
            identifier: data.identifier
        }
    ).then((response) => {
        if (response.data.status !== 1) {
            throw new Error(response.data.message);
        } else {
            const resp: CriminalRecordInterface = interceptorResponse(response.data.object)
            if (resp === null) {
                // msjLine(data.msj)
            }
            return resp
        }
    }).catch(error => {
        errorHandlerServices(error, true, '/criminal_record', undefined, data?.msj)
        getError(error,
            error?.response?.data?.message ?
                error?.response?.data?.message : `Error service: /criminal_record`);
    })
}

export const useFindCriminalRecords = (): UseMutationResult<any, Error, any, unknown> => {
    return useMutation({
        mutationFn: (data: SearchParamsInterface) => findCriminalRecords(data),
    });
}

export const findOffendedDemands = async (data: SearchParamsInterface) => {
    return await configAxios.post(
        `/legal_cases/demands/offended`,
        {
            identifier: data.identifier
        }
    ).then((response) => {
        if (response.data.status !== 1) {
            throw new Error(response.data.message);
        } else {
            const resp: DemandsInterface[] = interceptorResponse(response.data.object)
            if (resp === null || (resp && resp.length === 0)) {
                // msjLine(data.msj)
            }
            return resp
        }
    }).catch(error => {
        errorHandlerServices(error, true, '/legal_cases/demands', undefined, data?.msj)
        getError(error,
            error?.response?.data?.message ?
                error?.response?.data?.message : `Error service: /legal_cases/demands`);
    })
}

export const useFindOffendedDemands = (): UseMutationResult<any, Error, any, unknown> => {
    return useMutation({
        mutationFn: (data: SearchParamsInterface) => findOffendedDemands(data),
    });
}

export const findOffenderDemands = async (data: SearchParamsInterface) => {
    return await configAxios.post(
        `/legal_cases/demands/defendant`,
        {
            identifier: data.identifier
        }
    ).then((response) => {
        if (response.data.status !== 1) {
            throw new Error(response.data.message);
        } else {
            const respDemands: DemandsInterface[] = interceptorResponse(response.data.object)
            if (respDemands === null || (respDemands && respDemands.length === 0)) {
                // msjLine(data.msj)
            }
            return respDemands
        }
    }).catch(error => {
        errorHandlerServices(error, true, '/pn_demandas', undefined, data?.msj)
        getError(error,
            error?.response?.data?.message ?
                error?.response?.data?.message : `Error service: /pn_demandas`);
    })
}

export const useFindOffenderDemands = (): UseMutationResult<any, Error, any, unknown> => {
    return useMutation({
        mutationFn: (data: SearchParamsInterface) => findOffenderDemands(data),
    });
}

export const findSupa = async (data: SearchParamsInterface) => {
    return await configAxios.post(
        `/legal_cases/alimony`,
        {
            identifier: data.identifier
        }
    ).then((response) => {
        if (response.data.status !== 1) {
            throw new Error(response.data.message);
        } else {
            const resp: SupaInterface[] = interceptorResponse(response.data.object)
            if (resp === null || (resp && resp.length === 0)) {
                // msjLine(data.msj)
            }
            return resp
        }
    }).catch(error => {
        errorHandlerServices(error, true, '/legal_cases/alimony', undefined, data?.msj)
        getError(error,
            error?.response?.data?.message ?
                error?.response?.data?.message : `Error service: /legal_cases/alimony`);
    })
}

export const useFindSupa = (): UseMutationResult<any, Error, any, unknown> => {
    return useMutation({
        mutationFn: (data: SearchParamsInterface) => findSupa(data),
    });
}

export const findComplaints = async (data: SearchParamsInterface) => {
    return await configAxios.post(
        `/legal_cases/complaints`,
        {
            identifier: data.identifier
        }
    ).then((response) => {
        if (response.data.status !== 1) {
            throw new Error(response.data.message);
        } else {
            const resp: ComplaintInterface[] = interceptorResponse(response.data.object)
            if (resp === null || (resp && resp.length === 0)) {
                // msjLine(data.msj)
            }
            return resp
        }
    }).catch(error => {
        errorHandlerServices(error, true, '/legal_cases/complaints', undefined, data?.msj)
        getError(error,
            error?.response?.data?.message ?
                error?.response?.data?.message : `Error service: /legal_cases/complaints`);
    })
}

export const useFindComplaints = (): UseMutationResult<any, Error, any, unknown> => {
    return useMutation({
        mutationFn: (data: SearchParamsInterface) => findComplaints(data),
    });
}
